<template>
  <div
    v-show="selected"
    class="tab-content"
    role="tabpanel"
    :id="title.toLowerCase().replace(/\s/g, '-')"
    :aria-labelledby="title.toLowerCase().replace(/\s/g, '-') + '-tab'"
    tabindex="0"
  >
    <div class="tab-pane fade show active">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    title: {
      type: String,
    },
    selected: {
      type: Boolean,
    },
  },
});
</script>
